import React from "react";
import Button from "../atoms/Button";

export default function Input({
  variant = "default",
  width,
  placeholder,
  buttonText = "Subscribe",
  buttonProps = {},
  containerStyle = {},
  inputStyle = {},
  ...props
}) {
  const isWithButton = variant === "withBtn";

  const wrapperStyles = isWithButton
    ? {
        display: "flex",
        alignItems: "center",
        width: width || "100%",
        maxWidth: width || "486px",
        backgroundColor: "var(--white)",
        border: "1px solid var(--greenG1)",
        borderRadius: "46px",
        overflow: "hidden",
        ...containerStyle,
      }
    : {
        display: "flex",
        alignItems: "center",
        width: width || "100%",
        maxWidth: width || "424px",
        backgroundColor: "var(--white)",
        border: "1px solid var(--gray1)",
        borderRadius: "6px",
        ...containerStyle,
      };

  const sharedInputStyles = {
    width: "100%",
    boxSizing: "border-box",
    border: "none",
    outline: "none",
    backgroundColor: "transparent",
    color: "var(--gray9)",
    fontFamily: "inherit",
    fontWeight: "400",
    fontSize: "16px",
    lineHeight: "130%",
  };

  return (
    <div style={wrapperStyles}>
      <input
        {...props}
        placeholder={placeholder}
        style={{
          ...sharedInputStyles,
          padding: isWithButton ? "16px 24px" : "14px 16px",
          ...inputStyle,
        }}
      />

      {isWithButton && (
        <Button
          size="medium"
          variant="fill"
          type="button"
          style={{
            flexShrink: 0,
            alignSelf: "stretch",
            borderRadius: "0 46px 46px 0",
            padding: "0 40px",
            margin: 0,
          }}
          {...buttonProps}
        >
          {buttonText}
        </Button>
      )}
    </div>
  );
}
